import Cookies from 'yoda-core-components/lib/helpers/Cookies/Cookies';
import { ENABLE_COOKIE_PARAM, DISABLE_COOKIE_PARAM } from './parseOnetrustConfig.config';

const getCookie = (cookieConstant) => {
    return Cookies.load(cookieConstant, true) || '';
};

export const isCookieEnabled = (categoryCode, cookieConstant) =>
    getCookie(cookieConstant).includes(categoryCode + ENABLE_COOKIE_PARAM);

export const isCookieDisabled = (categoryCode, cookieConstant) =>
    getCookie(cookieConstant).includes(categoryCode + DISABLE_COOKIE_PARAM);
